import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";

import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";import {useNavigate} from "react-router-dom";
import {
    findUsersByCompanyIdAndQueryString,
    findUsersByQueryString,
    isUserAdmin
} from "../../utils/requestUtils";
import {UserPermission} from "../../utils/utils";
import Config from "../../core/config";
import Loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";

const apiUrl = Config.apiUrl;
const UserList = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    let [users, setUsers] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    const url = window.location.pathname;

    const admin = url.startsWith('/admin');

    async function makeQuery(query) {
        try {
            setLoading(true);
            const response = admin ? await findUsersByQueryString(query) : await findUsersByCompanyIdAndQueryString(query);
            console.log('Search query:', query, 'Response:', response);
            setUsers(response || []);
        } catch (error) {
            console.error('Error fetching data:', error);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if(url.startsWith('/admin')) {
            isUserAdmin().then(userAdmin => {
                if (!userAdmin)
                    navigate('/unauthorizedaccess');
            });
        }
    }, []);

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []); // Empty dependency array ensures that useEffect runs only once, similar to componentDidMount

    async function deleteUser(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/users/' + id;
            await makeRequest(url, 'DELETE');
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        // Search immediately for any input, not just 3+ characters
        makeQuery(string);
        setQueryString(string);
    };

    if (loadingPermissions) {
        return <Loading/>;
    }
    if(!admin && hasUserPermission(UserPermission.LIST_USER) === false) {
        navigate('/unauthorizedaccess');
    }
    return (
        <>
            <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                <div className="header-label">Consulta de Usuários</div>
                {hasUserPermission(UserPermission.CREATE_USER) &&
                    <button className={"new-button"}
                            onClick={() => navigate(`/${admin ? 'admin' : 'app'}/user`)}>Novo</button>
                }
            </div>

            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <input 
                    ref={inputQueryString} 
                    type="text" 
                    value={queryString} 
                    onChange={handleInputChange}
                    placeholder="Buscar por nome ou email..."
                    style={{width: '300px'}}
                />
            </div>

            <table style={{width: '580px'}}>

                <tr>
                    <th>
                        Nome
                    </th>
                    <th>
                        e-mail
                    </th>
                    <th/>
                    <th/>
                </tr>
                <tbody style={{overflowY: 'auto'}}>

                {users.map((user, index) => (


                    <tr>

                        <td>
                            <div key={index}>{user.name}</div>
                        </td>
                        <td>
                            <div key={index}>{user.email}</div>
                        </td>
                        <td>
                            {hasUserPermission(UserPermission.EDIT_USER) &&
                                <button className="edit-button" onClick={async () => {
                                    await navigate(`/${admin ? 'admin' : 'app'}/user?id=${user.id}`);
                                }}>Editar
                                </button>
                            }
                        </td>
                        <td>
                            {hasUserPermission(UserPermission.REMOVE_USER) &&
                                <button className="remove-button" onClick={async () => {
                                    // eslint-disable-next-line no-restricted-globals
                                    if (window.confirm('Deseja realmente excluir?')) {
                                        await deleteUser(user.id);
                                    }
                                }}>Excluir
                                </button>
                            }
                        </td>

                    </tr>
                ))}
                </tbody>
                {users.length === 0 && (<tfoot>{loading ? 'Carregando...' : `Nenhum item encontrado.`}</tfoot>)}
            </table>


        </>
    );
};

export default UserList;
